<!-- 活动详情 -->
<template>
    <div class="activity-detail-container">
        <roof-search :middleContent="false" :rightContent="false" :placeholder="true" v-show="isShowNav"></roof-search>
        <div class="slider-container">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item,index) in caseDetails.img_url" :key="index" @click="previewImg(index)">
                    <van-image fit="contain" class="slider-img" :src="cdnUrl+item" />
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="activity-content">
            <div class="activity-title van-multi-ellipsis--l2">
                {{caseDetails.title}}
            </div>
            <div class="date-address">
                <div class="options">
                    <div class="left-icon">
                        <i class="iconfont icon-shijian"></i>
                    </div>
                    <div class="right-text">{{caseDetails.start_date}} 至 {{caseDetails.end_date}}</div>
                </div>
                <div class="options">
                    <div class="left-icon">
                        <i class="iconfont icon-weizhi"></i>
                    </div>
                    <div class="right-text">{{caseDetails.address}}</div>
                </div>
            </div>
            <van-divider :style="{borderColor: '#ECECEC'}" />
            <div class="activity-detail footer">
                <div class="activity-title hint-title">活动详情</div>
                <div class="details" v-html="caseDetails.desc" ref="caseDetails" @click="seeBigImg"></div>
            </div>
        </div>
        <div class="bottom-btn-container footer" v-if="!pastState && is_need_sign_up == 1">
            <button class="bottom-btn" v-if="!caseDetails.redirect_url" :class="is_book?'past-btn':''" @click="is_book?'':commitSignUp()">{{button_text}}</button>
            <button class="bottom-btn" v-if="caseDetails.redirect_url" @click="commitSignUp()">{{button_text}}</button>
        </div>

        <!-- 默认表单 -->
        <default-form ref="defaultForm" :caseDetails="caseDetails"></default-form>

        <!-- 自定义表单 -->
        <customer-form ref="customerForm" :caseDetails="caseDetails" :formItem="applyFormItem" :formDataList="applyFormDataList" @proList="proList" :showACode="showACode"></customer-form>

        <!-- 活动结束的提示 -->
        <van-popup v-model="finishPopup" :safe-area-inset-bottom="true">
            <div class="success-container">
                <img src="@/assets/img/close-icon.png" class="success-img" alt="">
                <h3 class="h3-tit">活动已结束</h3>
                <div class="close-icon" @click="finishPopup = false">
                    <i class="iconfont icon-quxiao"></i>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import roofSearch from '@/components/roof-search'
import { getActivityDetails, activitySign, createTagForUser } from '@/api/activity'
import defaultForm from '@/views/sceneActivity/components/default-form'
import customerForm from '@/views/sceneActivity/components/customer-form'
import { wxShare } from '@/libs/wxjssdk'
import { ImagePreview } from 'vant'
export default {
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            id: '',
            isShowNav: false,
            caseDetails: {},
            pastState: true,
            is_need_sign_up: 0, // 是否显示报名按钮
            is_book: false, // 是否报名
            is_sign: false, // 是否签到
            qr_sign: false, // 是否是扫码签到
            button_text: '参与活动',
            expectState: [
                { is_book: false, is_sign: false, qr_sign: true }, // 扫码进入签到的;没报名、没签到
                { is_book: true, is_sign: false, qr_sign: true }, // 扫码进入签到的;已经报名、没签到
                { is_book: true, is_sign: true, qr_sign: true }, // 扫码进入签到的;已经报名、已经签到
                { is_book: true, is_sign: false, qr_sign: false }, // 跳转链接进入的;已经报名、没签到
                { is_book: true, is_sign: true, qr_sign: false } // 跳转链接进入的;已经报名、已经签到
            ],
            stateIndexOf: -1,
            finishPopup: false,
            applyFormItem: {},
            applyFormDataList: [],
            showACode: 0
        }
    },
    components: { defaultForm, roofSearch, customerForm },
    created () {
        this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        })
        var query = this.$route.query
        this.id = query.id || ''
        this.isShowNav = query.isShowNav || false
        this.qr_sign = Boolean(parseInt(query.qr_sign)) || false
        this.getExampleDetailPort()
        this.proList()

    },
    
    mounted () {
        // this.$refs.caseDetails.addEventListener('click', (e) => {
        //   console.log('单击了', e)
        //   console.log(e.toElement.src)
        // })
        localStorage.removeItem('defalFrom')
        localStorage.removeItem('cusFrom')
        // console.log('清空缓存')
        
    },
    beforeDestroy () {
    //   console.log('销毁');
    },
    deactivated () {
        // console.log('离开');
    },
    methods: {
        proList(data) {
            console.log('父组件的',data);
            this.applyFormDataList = data
            // this.applyFormDataList.activity_id = this.$route.query.id
            
        },
        sharePage () {
            const params = {
                title: this.caseDetails.title || '小 E 活动', // 分享标题
                desc: '点击此处参与活动', // 分享描述
                link: `${
                    window.location.href.split('#')[0]
                }#/activityDetail?id=${this.id}&isShowNav=true`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                // imgUrl: `${this.cdnUrl}${this.caseDetails.img_url[0]}` // 分享图标
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            wxShare(params)
        },
        // 单击预览图片
        previewImg (index) {
            var wrapImgs = []
            this.caseDetails.img_url.map((val) => {
                wrapImgs.push(this.cdnUrl + val)
            })
            ImagePreview({
                images: wrapImgs,
                startPosition: index
            })
        },
        // 单击立即报名
        commitSignUp () {
            console.log('caseDetails', this.caseDetails)
            var caseDetails = this.caseDetails
            if (caseDetails.redirect_url && !caseDetails.is_form) {
                // 如果设置跳转链接，但不需要填写表单
                this.createTagForUserPort()
                window.location.href = this.caseDetails.redirect_url
            } else if (caseDetails.redirect_url && caseDetails.is_form && this.is_book) {
                // 如果设置跳转链接，但需要填写表单，并且填写过表单
                
                this.createTagForUserPort()
                window.location.href = this.caseDetails.redirect_url
            } else {
                if (caseDetails.form_id !== 0) {
                    caseDetails.form.keys.forEach(item => {
                        if (item.type === 2) {
                            this.applyFormItem[item.field] = []
                        } else {
                            this.applyFormItem[item.field] = ''
                        }
                        
                    })
                    this.applyFormDataList = [...caseDetails.form.keys]
                    let moIndex = ''
                    // console.log('直接添加内容',this.applyFormDataList);
                    // console.log('直接添加内容---',this.applyFormItem);
                    this.applyFormDataList.filter((value,index) => {
                        if (value.field == 'mobile') {
                            moIndex = index
                        }
                    })
                    
                    if (moIndex) {
                        let moblie = {
                            field: 'code',
                            required: 1,
                            title: '验证码',
                            type: 3,
                            value: "",
                            placeholder: "请输入验证码"
                        }
                        this.applyFormDataList.splice(moIndex+1, 0, moblie)
                    }
                    let newCus = JSON.stringify(this.applyFormDataList)
                    localStorage.setItem('customNewFild',newCus)
                    // console.log('父组件 表单',this.applyFormDataList,moIndex);
                    
                }
                this.showApplyForm()
            }
        },

        // 显示表单
        showApplyForm () {
            if (this.caseDetails.form_id === 0) {
                // console.log('123456',this.caseDetails)
                this.$refs.defaultForm.activity_id = this.id
                this.$refs.defaultForm.showApplyForm()
            } else {
                this.$refs.customerForm.activity_id = this.id
                this.$refs.customerForm.showApplyForm()
            }
        },

        // 判断按钮显示
        buttonLogic () {
            var stateIndexOf = this.expectState.findIndex((item) => {
                return (
                    item.is_book === this.is_book &&
                    item.is_sign === this.is_sign &&
                    item.qr_sign === this.qr_sign
                )
            })
            // console.log('打印结果', stateIndexOf)
            this.stateIndexOf = stateIndexOf
            var endSignup = this.caseDetails.end_signup
            var end = this.$moment(this.caseDetails.end_signup).valueOf()
            var now = new Date().getTime()
            switch (stateIndexOf) {
            case -1:
                // 没报名、没签到 非扫码进入的
                if (endSignup !== null && endSignup !== '""') {
                    if (now > end) {
                        this.is_book = true
                        this.button_text = '报名时间已截止'
                    }
                }
                break
            case 0:
                // 扫码进入签到的;没报名、没签到
                if (endSignup !== null && endSignup !== '""') {
                    if (now > end) {
                        this.is_book = true
                        this.button_text = '报名时间已截止'
                    } else {
                        this.$refs.defaultForm.activity_id = this.id
                        this.$refs.defaultForm.formItem.is_sign = '1'
                        this.$refs.defaultForm.showApplyForm()
                    }
                }
                break
            case 1:
                // 扫码进入签到的;已经报名、没签到；调用签到接口
                console.log('调用签到接口')
                this.activitySignPort()
                this.button_text = '已报名'
                break
            case 2:
                // 扫码进入签到的;已经报名、已经签到； 提示已经签到成功
                // this.$toast(
                //   {
                //     message: '签到成功',
                //     duration: 3000
                //   }
                // )
                this.button_text = '已签到'
                break
            case 3:
                // 跳转链接进入的;已经报名、没签到
                if (this.caseDetails.redirect_url && this.caseDetails.is_form) {
                    this.button_text = '参与活动'
                } else {
                    this.button_text = '已报名'
                }
                break
            case 4:
                // 跳转链接进入的;已经报名、已经签到
                this.button_text = '已签到'
                break
            }
        },
        /** 网络请求 **/
        // 根据id 获取案例分享详情
        getExampleDetailPort () {
            getActivityDetails({ id: this.id }).then((res) => {
                if (res.errCode === 0) {
                    
                    this.$toast.clear()
                    var data = res.data
                    if (data.form) {
                        data.form.keys.forEach(value => {
                            if (value.field == 'products' || value.field == 'intention') {
                                this.showACode =  1
                            }else {
                                this.showACode =  2
                            }
                        })
                    } else {
                        this.showACode =  1
                    }
                    
                    console.log('=======', this.showACode);
                    var caseDetails = data
                    caseDetails.img_url = JSON.parse(caseDetails.img_url)
                    this.caseDetails = caseDetails
                    // console.log('hbsdjfbjhdsf看看',caseDetails)
                    this.sharePage()
                    // 判断是否是往期的活动, true是往期  false是近期
                    var pastState = () =>
                        this.$moment(caseDetails.end_date).valueOf() <
                        new Date().getTime()
                    this.pastState = pastState()

                    caseDetails.start_date = caseDetails.start_date.substr(0, 16)
                    caseDetails.end_date = caseDetails.end_date.substr(0, 16)

                    this.is_book = caseDetails.is_book
                    this.is_sign = caseDetails.is_sign
                    this.is_need_sign_up = caseDetails.is_need_sign_up
                    if (!this.pastState) {
                        // 是近期活动
                        this.buttonLogic()
                    } else if (this.qr_sign) {
                        // 是往期活动
                        this.finishPopup = true
                    }
                } else {
                    this.$toast.clear()
                    this.$toast(res.errMsg)
                }
            }).catch((err) => {
                console.log('案例分享详情接口失败', err)
                this.$toast('案例分享详情接口失败')
            })
        },
        // 活动签到接口
        activitySignPort () {
            var params = {
                user_id: this.$store.state.user.id || '',
                activity_id: this.id,
                is_sign: 1
            }
            activitySign(params)
                .then((res) => {
                    if (res.errCode === 0) {
                        this.button_text = '已签到'
                        this.$refs.defaultForm.successHint = '签到成功'
                        this.$refs.defaultForm.commitSuccess = true
                    } else {
                        this.$toast(res.errMsg)
                    }
                })
                .catch((err) => {
                    console.log('活动签到接口失败', err)
                    this.$toast('活动签到接口失败')
                })
        },
        // 跳转外链，为用户打标签
        createTagForUserPort () {
            if (this.caseDetails.tag_arr) {
                var params = {
                    tag_id: this.caseDetails.tag_id,
                    openid: this.$store.state.user.openid
                }
                // console.log('打印参数', params)
                createTagForUser(params).then((res) => {})
            } else {
                console.log('未关联标签')
            }
        },
        seeBigImg (event) {
            if (event.target.nodeName === 'IMG' && event.target.className === 'seeBigImg') {
                console.log(event.target.src)
                var wrapImgs = []
                wrapImgs.push(event.target.src)
                ImagePreview({
                    images: wrapImgs,
                    startPosition: 0
                })
            }
        }
    }
}
</script>

<style lang="scss">
em {
    font-style: italic;
}
.activity-detail-container {
    background: #fff;
    padding-bottom: rem(70);
    .slider-container {
        width: 100%;
        height: rem(230);
        background: #cfcfcf;
        .my-swipe {
            height: 100%;
            .slider-img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .activity-content {
        padding: 0 rem(20);
        .activity-title {
            margin: rem(13) 0;
            font-size: rem(15);
            font-weight: 500;
            color: #2c2c2c;
            line-height: rem(25);
            position: relative;
            padding-left: rem(13);
            &:after {
                content: '';
                width: rem(7);
                height: rem(17);
                background: $base-color;
                position: absolute;
                top: rem(5);
                left: 0;
            }
        }
        .date-address {
            .options {
                display: flex;
                color: #4c4c4c;
                font-size: rem(14);
                .left-icon {
                    width: rem(25);
                    .icon-shijian {
                        font-size: rem(19);
                        color: $base-color;
                    }
                    .icon-weizhi {
                        font-size: rem(18);
                        color: $base-color;
                    }
                }
                .right-text {
                    flex: 1;
                }
            }
        }
        .activity-detail {
            overflow: hidden;
            .hint-title {
                margin-top: 0;
                margin-bottom: rem(8);
            }
            img {
                max-width: 100%;
                height: auto;
            }
        }
    }
    .bottom-btn-container {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        .bottom-btn {
            width: 100%;
            height: rem(50);
            /*bottom: constant(safe-area-inset-bottom);
        /*bottom: env(safe-area-inset-bottom); */
            bottom: 0;
            background: $base-color;
            color: #fff;
            font-size: rem(16);
            outline: none;
            border: none;
            &:after {
                content: '';
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                width: 100%;
                height: constant(safe-area-inset-bottom);
                height: env(safe-area-inset-bottom);
                background: #fff;
            }
        }
        .past-btn {
            background: #dedede;
        }
    }
    .success-container {
        width: rem(303);
        height: rem(250);
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        .success-img {
            width: rem(84);
            height: rem(84);
        }
        .h3-tit {
            font-size: rem(16);
            color: #2c2c2c;
            margin: rem(10) 0;
        }
        .hint-text {
            color: #bdbdbd;
            font-size: 13px;
        }
        .close-icon {
            position: absolute;
            top: rem(15);
            right: rem(15);
            width: rem(20);
            height: rem(20);
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                font-weight: bold;
                font-size: rem(25);
                color: #9d9d9d;
            }
        }
    }
}
</style>
